export const type = 'form.dateRangePicker';
